import { deepcopy } from "../util.js";

export function translateAddDataFilter(tech, args, line, parsed, source, mapping, processed, config) {
  let rules = [];
  if (args[0] === "global" && config.recommender.data_filter !== undefined) {
    rules.push({
      category: "recommender",
      description: `Remve a data subset`,
      specifier: {
        role: "data",
        data: deepcopy(config.recommender.data_filter)
      },
      action: "remove"
    });
  }
  return rules;
}